module.exports = __webpack_public_path__ + "static/3b-fb3f9b1d23eb5d6067541b1e3aaa5f4a.png";